/**
 * ServiceContainer - minimal DI registry to reduce circular dependencies.
 */
class ServiceContainer {
  constructor() {
    this.services = new Map();
    this.factories = new Map();
  }
  register(name, factory) { this.factories.set(name, factory); }
  set(name, instance) { this.services.set(name, instance); }
  get(name) {
    if (this.services.has(name)) return this.services.get(name);
    const f = this.factories.get(name);
    if (typeof f === 'function') {
      const inst = f(this);
      this.services.set(name, inst);
      return inst;
    }
    return undefined;
  }
}

export const container = new ServiceContainer();
export default container;

